import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private authService: AuthService,
    private router: Router) { }

    canActivate(state: RouterStateSnapshot): boolean { 
      let url: any = state.url;
  
        if (this.authService.isUserLoggedIn()) {
            return true;
        }
        this.authService.setRedirectUrl(url[0].path);
        this.router.navigate([this.authService.getLoginUrl()]);
        return false;
    }
}


// checkForceUpdatePass(state: RouterStateSnapshot): boolean {  
//   if (this.authService.checkForceUpdate()) {
//       return true;
//   }
//   // this.authService.setRedirectUrl(url[0].path);
//   // this.router.navigate([this.authService.getLoginUrl()]);
//   return false;
// }
